import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'gorthmikon';
const args = {};

export class Gorthmikon extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
